import React from "react";
import { motion } from "framer-motion";
import { COVER } from "@/constants/testIds";

const reveal = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 1.05, ease: [0.22, 0.61, 0.36, 1], delay: i * 0.12 },
  }),
};

const CoverStatus = () => {
  return (
    <section
      id="cover-status"
      data-testid={COVER.section}
      className="relative w-full py-28 md:py-40 lg:py-48"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-start">
          {/* Vitrine */}
          <motion.div
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }}
            custom={0}
            className="md:col-span-5"
          >
            <div className="vitrine max-w-[320px] mx-auto md:mx-0" data-testid={COVER.vitrine}>
              <span className="v-c1" aria-hidden="true" />
              <span className="v-c2" aria-hidden="true" />
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
                <p className="overline mb-4" style={{ color: "var(--soti-ash-dim)" }}>
                  Vitrine
                </p>
                <p
                  className="font-display italic text-[#A19D99] text-xl leading-snug"
                >
                  Awaiting the artifact.
                </p>
                <span
                  className="mt-6 inline-block w-6 h-px"
                  style={{ background: "var(--soti-cinder)", opacity: 0.85 }}
                  aria-hidden="true"
                />
                <p
                  className="overline mt-6"
                  style={{ color: "var(--soti-ash-dim)" }}
                >
                  In Development
                </p>
              </div>
            </div>
          </motion.div>

          {/* Text column */}
          <div className="md:col-span-7">
            <motion.div
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.3 }}
              custom={1}
              className="flex items-center gap-4 mb-8"
            >
              <span className="rule rule-cinder" aria-hidden="true" />
              <p className="overline">Cover & Key Art</p>
            </motion.div>

            <motion.h2
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.3 }}
              custom={2}
              data-testid={COVER.heading}
              className="font-display text-[#F3EFEA] text-3xl sm:text-4xl md:text-5xl leading-[1.06] tracking-[-0.02em] max-w-xl"
            >
              Cover and key art are currently in development.
            </motion.h2>

            <motion.p
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.3 }}
              custom={3}
              data-testid={COVER.body}
              className="mt-8 max-w-xl text-[#D9D4CD] text-base sm:text-lg leading-relaxed font-light"
            >
              Final public visuals are in development. No final cover art has
              been released yet.
            </motion.p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoverStatus;
